module.exports = __webpack_public_path__ + "img/icon-done.3da9ef41.svg";